export default __webpack_public_path__ + "static/B0159-d341a7c17433b18127403f7394322e47.png";